import React, { Component } from 'react';
import './scss/app.scss';
import ClientRoute from './routes/ClientRoute';

// pages
import MultiMarketPage from './pages/multiMarketPage';
import BetsHistoryPage from './pages/betsHistoryPage';
import HowtoplayPage from './pages/howtoplayPage';
import BetsSettledHistoryPage from './pages/betsSettledHistoryPage';
import BalanceHistoryPage from './pages/balanceHistoryPage';
import PrizesPage from './pages/prizesPage'
import TermsAndConditionsPage from './pages/termsAndConditionsPage'

class App extends Component {
  render() {
    const { location } = this.props;
    return (
      <div>
        <ClientRoute exact path='/' component={MultiMarketPage} />
        <ClientRoute exact path='/bet-history' component={BetsHistoryPage} />
        <ClientRoute exact path='/bet-settled-history' component={BetsSettledHistoryPage} />
        <ClientRoute exact path='/balance-history' component={BalanceHistoryPage} />
        <ClientRoute exact path='/how-to-play' component={HowtoplayPage} />
        <ClientRoute exact path='/prizes' component={PrizesPage} />
        <ClientRoute exact path='/terms-and-conditions' component={TermsAndConditionsPage} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./app.js